export const firebaseConfig = {
  apiKey: 'AIzaSyBtY338C_F7-j3HKL4xCT4RT3OxDZgn3TI',
  authDomain: 'sun-asterisk-matex.firebaseapp.com',
  projectId: 'sun-asterisk-matex',
  storageBucket: 'sun-asterisk-matex.appspot.com',
  messagingSenderId: '164441612459',
  appId: '1:164441612459:web:a4dc66ae5e399dc3b797ee',
};
